import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "rounded-lg bg-slate-50 p-2"
};
const _hoisted_2 = {
  key: 0,
  class: "flex items-center gap-2"
};
const _hoisted_3 = ["disabled"];
const _hoisted_4 = {
  class: "text-xs text-slate-600"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  key: 2,
  class: "text-xs text-slate-400"
};
import { onMounted, reactive, ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { getSpaceAcl, shareSpace, unshareSpace } from '@/api/aiSpace';
export default {
  __name: 'SpaceAclPanel',
  props: {
    /** 目标空间 id */
    spaceId: {
      type: [Number, String],
      default: null
    },
    /** 可编辑权限：false 时仅展示授权列表，不可授权/撤销 */
    editable: {
      type: Boolean,
      default: true
    }
  },
  emits: ['changed'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const shareForm = reactive({
      subjectType: 'USER',
      subjectId: '',
      level: 'VIEW'
    });
    const aclList = ref([]);
    const sharing = ref(false);
    const SUBJECT_TYPE_TEXT = {
      USER: '指定用户',
      DEPT: '指定部门',
      ALL_AUTHENTICATED: '全员'
    };
    function subjectTypeText(t) {
      return SUBJECT_TYPE_TEXT[t] || t;
    }

    /** 既有授权列表（GET /acl 端点未就绪时静默降级为空） */
    async function loadAcl() {
      if (!props.spaceId) {
        aclList.value = [];
        return;
      }
      try {
        const list = await getSpaceAcl(props.spaceId);
        aclList.value = Array.isArray(list) ? list : list && list.records || [];
      } catch {
        aclList.value = [];
      }
    }
    async function handleShare() {
      if (shareForm.subjectType !== 'ALL_AUTHENTICATED' && !shareForm.subjectId) {
        ElMessage.warning('请输入主体 ID');
        return;
      }
      sharing.value = true;
      try {
        await shareSpace(props.spaceId, {
          subjectType: shareForm.subjectType,
          subjectId: shareForm.subjectType === 'ALL_AUTHENTICATED' ? 0 : Number(shareForm.subjectId),
          level: shareForm.level
        });
        shareForm.subjectId = '';
        await loadAcl();
        emit('changed');
        ElMessage.success('已授权');
      } catch (err) {
        ElMessage.error(err && err.message || '授权失败');
      } finally {
        sharing.value = false;
      }
    }

    /** 撤销授权：unshareSpace 与 shareSpace 同一 camelCase 载荷 */
    async function handleUnshare(a) {
      try {
        await unshareSpace(props.spaceId, {
          subjectType: a.subjectType,
          subjectId: a.subjectId,
          level: a.level
        });
        await loadAcl();
        emit('changed');
        ElMessage.success('已撤销');
      } catch (err) {
        ElMessage.error(err && err.message || '撤销失败');
      }
    }
    watch(() => props.spaceId, () => {
      shareForm.subjectId = '';
      loadAcl();
    });
    onMounted(loadAcl);
    __expose({
      reload: loadAcl
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [__props.editable ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => shareForm.subjectType = $event),
        class: "form-select-native form-control-sm"
      }, [...(_cache[3] || (_cache[3] = [_createElementVNode("option", {
        value: "USER"
      }, "指定用户", -1), _createElementVNode("option", {
        value: "DEPT"
      }, "指定部门", -1), _createElementVNode("option", {
        value: "ALL_AUTHENTICATED"
      }, "全员", -1)]))], 512), [[_vModelSelect, shareForm.subjectType]]), shareForm.subjectType !== 'ALL_AUTHENTICATED' ? _withDirectives((_openBlock(), _createElementBlock("input", {
        key: 0,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => shareForm.subjectId = $event),
        class: "form-input form-control-sm w-24",
        placeholder: "主体 ID"
      }, null, 512)), [[_vModelText, shareForm.subjectId]]) : _createCommentVNode("", true), _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => shareForm.level = $event),
        class: "form-select-native form-control-sm"
      }, [...(_cache[4] || (_cache[4] = [_createElementVNode("option", {
        value: "VIEW"
      }, "可查看", -1), _createElementVNode("option", {
        value: "MANAGE"
      }, "可管理", -1)]))], 512), [[_vModelSelect, shareForm.level]]), _createElementVNode("button", {
        class: "btn-primary form-control-sm",
        disabled: sharing.value,
        onClick: handleShare
      }, "授权", 8, _hoisted_3)])) : _createCommentVNode("", true), aclList.value.length ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(__props.editable ? 'mt-2 border-t border-slate-200 pt-2' : '')
      }, [_cache[5] || (_cache[5] = _createElementVNode("p", {
        class: "mb-1 text-xs font-medium text-slate-400"
      }, "既有授权", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aclList.value, a => {
        return _openBlock(), _createElementBlock("div", {
          key: a.id,
          class: "flex items-center justify-between py-1"
        }, [_createElementVNode("span", _hoisted_4, [_createTextVNode(_toDisplayString(subjectTypeText(a.subjectType)), 1), a.subjectType !== 'ALL_AUTHENTICATED' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createTextVNode(" #" + _toDisplayString(a.subjectId), 1)], 64)) : _createCommentVNode("", true), _createTextVNode(" · " + _toDisplayString(a.level === 'MANAGE' ? '可管理' : '可查看'), 1)]), __props.editable ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "text-xs text-red-500 hover:underline",
          onClick: $event => handleUnshare(a)
        }, "撤销", 8, _hoisted_5)) : _createCommentVNode("", true)]);
      }), 128))], 2)) : !__props.editable ? (_openBlock(), _createElementBlock("p", _hoisted_6, "未共享（仅授权范围可见）")) : _createCommentVNode("", true)]);
    };
  }
};